import { Box, Button, FormHelperText, Stack } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import AuthenticationLayout from "page-sections/authentication/AuthenticationLayout";
import AppTextField from "components/input-fields/AppTextField";
import CountDownTimer from "../../components/CountDownTimer";
import { useFormik } from "formik";
import { FC, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { checkForgetPasswordRequest } from "../../request/UserRequest";

const ForgetPasswordVerifyCode: FC = () => {
  const navigate = useNavigate();
  const [error] = useState("");
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const validationSchema = Yup.object().shape({
    code: Yup.string().required("Введите код"),
  });

  const { errors, values, touched, handleBlur, handleChange, handleSubmit } = useFormik({
    initialValues: { code: "" },
    validationSchema,
    onSubmit: async (values, { setErrors }) => {
      setLoading(true);
      try {
        await checkForgetPasswordRequest(location.state.code, values.code);
        navigate("/new-password", {
          state: { privateCode: values.code, publicCode: location.state.code },
        });
      } catch (err: any) {
        setErrors({ code: err?.privateCode?.join(", ") || "Неверный код" });
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <AuthenticationLayout
      title="Подтверждение номера"
      subtitle="На указанный номер отправлен код. Введите его, чтобы задать новый пароль"
      route="/login"
      description="Вспомнили пароль?"
      routeName="Войти"
    >
      <form noValidate onSubmit={handleSubmit}>
        <Stack spacing={2.5}>
          <Box sx={{ textAlign: "center" }}>
            <CountDownTimer minutes={30} />
          </Box>

          <AppTextField
            fullWidth
            label="Код из SMS"
            name="code"
            type="text"
            inputMode="numeric"
            value={values.code}
            onBlur={handleBlur}
            onChange={handleChange}
            error={Boolean(touched.code && errors.code)}
            helperText={touched.code && errors.code}
          />

          {error && (
            <FormHelperText error sx={{ fontSize: 13, fontWeight: 500, textAlign: "center" }}>
              {error}
            </FormHelperText>
          )}

          {loading ? (
            <LoadingButton loading fullWidth size="large" variant="contained">
              Подтвердить
            </LoadingButton>
          ) : (
            <Button fullWidth size="large" type="submit" variant="contained">
              Подтвердить
            </Button>
          )}
        </Stack>
      </form>
    </AuthenticationLayout>
  );
};

export default ForgetPasswordVerifyCode;
